import { useRef } from 'react';
import { useSideBar } from '../sidebar';
export function useNavigation() {
  const navRef = useRef(null);
  const {
    expandStatus: sideBarExpandStatus,
    topSectionRef
  } = useSideBar();
  const displayStyle = sideBarExpandStatus === 'collapsed' ? 'collapsed' : 'expanded';

  const onNavKeyDown = onTab => ev => {
    const getNavItems = () => {
      var _navRef$current$query, _navRef$current;

      return Array.from((_navRef$current$query = (_navRef$current = navRef.current) === null || _navRef$current === void 0 ? void 0 : _navRef$current.querySelectorAll('[tabindex]:not([aria-hidden="true"])')) !== null && _navRef$current$query !== void 0 ? _navRef$current$query : []);
    };

    function focusNextItem(getNextIndex) {
      var _navLinks$nextIndex;

      if (!document.activeElement) {
        return;
      }

      const navLinks = getNavItems();
      const activeElementIndex = navLinks.findIndex(el => el === document.activeElement);

      if (activeElementIndex === -1) {
        return;
      }

      const nextIndex = getNextIndex(activeElementIndex, navLinks.length);
      (_navLinks$nextIndex = navLinks[nextIndex]) === null || _navLinks$nextIndex === void 0 ? void 0 : _navLinks$nextIndex.focus();
    }

    switch (ev.key) {
      case 'ArrowDown':
        {
          focusNextItem((currentIndex, navLinksLength) => Math.min(currentIndex + 1, navLinksLength - 1));
          break;
        }

      case 'ArrowUp':
        {
          focusNextItem(currentIndex => Math.max(currentIndex - 1, 0));
          break;
        }

      case 'Tab':
        {
          if (onTab) {
            onTab();
            break;
          }

          return;
        }

      default:
        return;
    }

    ev.stopPropagation();
    ev.preventDefault();
  };

  return {
    navRef,
    displayStyle,
    onNavKeyDown,
    navContainerRef: topSectionRef
  };
}